import { cn } from '@/lib/utils';
import { EnvelopeIcon } from '@phosphor-icons/react';
import useGetInboundEmail from '@/api/core/inbound-emails/getInboundEmail';

interface InboundEmailPreviewProps {
  entityId: string;
  className?: string;
}

export function InboundEmailPreview({
  entityId,
  className,
}: InboundEmailPreviewProps) {
  const { data: email, isLoading, isError } = useGetInboundEmail(entityId);

  if (isLoading) {
    return (
      <div className={cn('min-w-64 max-w-sm p-3', className)}>
        <div className="text-sm text-muted-foreground">Loading...</div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className={cn('min-w-64 max-w-sm p-3', className)}>
        <div className="text-sm text-muted-foreground">
          Failed to load email details
        </div>
      </div>
    );
  }

  if (!email) {
    return null;
  }

  return (
    <div className={cn('min-w-64 max-w-sm p-3', className)}>
      <div className="flex items-center gap-2 mb-2">
        <EnvelopeIcon className="size-4 text-muted-foreground" />
        <h4 className="text-sm font-semibold">Email Details</h4>
      </div>
      <div className="text-sm space-y-1">
        <div>
          <span className="text-muted-foreground">Subject: </span>
          <span className="font-medium">{email.subject || '(No subject)'}</span>
        </div>
        {email.textContent && (
          <div className="text-muted-foreground text-xs line-clamp-3 mt-2">
            {email.textContent}
          </div>
        )}
      </div>
    </div>
  );
}
